/**
 * Shopify Forms App - Label Fix
 * Injects styles into shadow DOM to fix floating labels
 */
(function() {
  'use strict';

  function fixShopifyFormsLabels() {
    document.querySelectorAll('.wishlist-enquiry-form shopify-forms-embed').forEach(function(host) {
      if (host.shadowRoot && !host.shadowRoot.querySelector('#shopify-forms-label-fix')) {
        var style = document.createElement('style');
        style.id = 'shopify-forms-label-fix';
        style.textContent = `
          [class*="_formFieldContainer"] {
            display: flex !important;
            flex-direction: column !important;
            gap: 6px !important;
          }
          [class*="_formFieldContainer"]:has(textarea)::before {
            display: none !important;
          }
          [class*="_formInputFieldLabel"] {
            position: static !important;
            transform: none !important;
            top: auto !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #374151 !important;
            order: -1 !important;
            background: transparent !important;
            padding: 0 !important;
          }
          [class*="_formInputField"],
          [class*="_textArea"] {
            padding: 12px !important;
          }
          [class*="_formPhoneInputContainer"] {
            display: flex !important;
            flex-direction: column !important;
            gap: 6px !important;
          }
          [class*="_formPhoneInputContainer"] [class*="_formFieldContainer"] {
            flex-direction: row !important;
          }

          [class*="_formFieldset"] {
            flex-direction: row !important;
            flex-wrap: wrap !important;
          }

          [class*="_formPhoneInputContainer"] [class*="_formFieldContainer"] label {
            display: none !important;
          }

          label._formInputFieldLabel_1mxsl_38 {
            padding: 0 !important;
          }

          [class*="_formContainer"] {
            width: 100% !important;
            max-width: 100% !important;
          }

          div._formFieldContainer_1mxsl_5, div._formPhoneInputContainer_piv1u_6 {
            flex: 1 calc(50% - 8px) !important;
          }

          div._formPhoneInputContainer_piv1u_6 {
            flex-direction: row !important;
            align-items: flex-end !important;
          }

           #phone_number {
            width: 100% !important;
          }

          .phone-country-selector {
            width: 80px !important;
          }

          .phone-country-selector button {
            height: 41px !important;
            padding: 10px 16px !important;
          }

          [data-testid="btn-form-submit"] {
            width: 100% !important;
          }
        `;
        host.shadowRoot.appendChild(style);
      }
    });
  }

  function init() {
    fixShopifyFormsLabels();
    setTimeout(fixShopifyFormsLabels, 1000);
    setTimeout(fixShopifyFormsLabels, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.fixShopifyFormsLabels = fixShopifyFormsLabels;
})();
